import { pickerController, PickerColumn } from '@ionic/core'
import { deliveryMobx, memberMobx, timePickMobx } from '@mobxStore'
import { cartMobx } from 'restaurant'
import { TimePickModal, SelectAddressModal } from '@cps'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import deliveryController from '@ctrls/deliveryController'

const _getDColumns = (_timePickList: any[], selectedIndex: number) => {
  const options = _timePickList?.map((item: any) => {
    const name = item.dayIndex === 0
      ? i18n.t('checkout.today')
      : item.dayIndex === 1
        ? i18n.t('checkout.tomorrow')
        : format.toDate(item.date, 'MM-DD')
    return {
      text: name,
      value: item.date,
      dayIndex: item.dayIndex,
      timeList: item.timeList
    }
  })
  return {
    name: 'day',
    options,
    selectedIndex
  } as PickerColumn
}

const _getHColumns = (timeList: any[], asapTime: any, selectedIndex: number) => {
  const options = timeList?.map((item: any) => {
    const name = item.pickTimeRangeStr ? item.pickTimeRangeStr : item.timeStr === ''
      ? asapTime.timeStr
      : format.toTime(item.timeStr, 'HH:mm')
    return {
      text: name,
      value: item.timeStr,
      pickTimeRange: item.pickTimeRange,
    }
  })
  return {
    name: 'hour',
    options,
    selectedIndex
  } as PickerColumn
}

const _showEditAddress = async () => {
  if (!deliveryMobx.hasAddresses) await memberMobx.getMemberAddress()
  if (!deliveryMobx.hasAddresses) {
    await deliveryController.editAddressModal({
      callback (store) {
      }
    })
  } else {
    if (deliveryMobx.availableAddress) {
      await deliveryMobx.setAddress(deliveryMobx.availableAddress)
    } else {
      await new Promise(function (resolve, reject) {
        modalLayer(SelectAddressModal, { }, 'SelectAddressModal').then(() => {
          resolve({})
        }, () => {
          reject()
        })
      })
    }
  }
}

class TimePickController {
  static handleInitProduct (no: string) {
    if (no) timePickMobx.initProduct(no)
  }
  static async handleAppointment (type: 'order' | 'product' = 'order', params?: { no?: string; startTime?: string; pickTimeRange?: string; callback?: () => void }) {
    const { no, startTime, pickTimeRange, callback } = params || {}
    let timePickList = []
    let selectedInfo
    if (deliveryMobx.isDelivery && !deliveryMobx.address) {
      await _showEditAddress()
      if (!deliveryMobx.address) return
    }
    if (type === 'order') {
      timePickMobx.init()
      timePickList = timePickMobx.timePickList
      selectedInfo = timePickMobx.selectedInfo
    } else {
      timePickMobx.initProduct(no, startTime, pickTimeRange)
      timePickList = timePickMobx.productTimePickList
      selectedInfo = timePickMobx.productSelectedInfo || {
        pickDayIndex: timePickList?.[0]?.dayIndex,
        pickTime: timePickList?.[0]?.timeList[0]?.timeStr,
        pickTimeRange: timePickList?.[0]?.timeList[0]?.pickTimeRange
      }
    }
    if (timePickList?.length > 7) {
      modalLayer.close('TimePickModal')
      return modalLayer(TimePickModal, { type, selectedInfo, timePickList, callback }, 'TimePickModal', true)
        .then((res: any) => { })
        .catch(() => { })
    } else {
      this.showPicker(type, params)
    }
  }
  static async showPicker (type: 'order' | 'product', params: { no?: string; info?: ITimePickInfo; callback?: () => void }) {
    if (document.querySelector('ion-picker.time-pick-picker')) return
    const { no, info, callback } = params || {}
    const { canNow, productCanNow, asapTime, productAsapTime, timePickList, selectedInfo, productTimePickList, productSelectedInfo } = timePickMobx
    const _timePickList = (type === 'order' ? timePickList : productTimePickList)
    const _info = info || (type === 'order' ? selectedInfo : productSelectedInfo || {
      pickDayIndex: _timePickList?.[0]?.dayIndex,
      pickDay: _timePickList?.[0]?.date,
      pickTime: _timePickList?.[0]?.timeList[0]?.timeStr,
      pickTimeRange: _timePickList?.[0]?.timeList[0]?.pickTimeRange
    })
    const _dColIdx = _timePickList?.findIndex(item => item.dayIndex === _info.pickDayIndex)
    const dColIdx = _dColIdx < 0 ? 0 : _dColIdx
    const hColIdx = _timePickList?.[dColIdx]?.timeList?.findIndex(item => item.timeStr === _info.pickTime)
    const _selectedInfo = {
      pickDayIndex: info ? info.pickDayIndex : _timePickList?.[dColIdx]?.dayIndex,
      pickDay: info ? info.pickDay : _timePickList?.[dColIdx]?.date,
      pickTime: info ? info.pickTime : _timePickList?.[dColIdx]?.timeList[0]?.timeStr,
      pickTimeRange: info ? info.pickTimeRange : _timePickList?.[0]?.timeList[0]?.pickTimeRange
    }
    const picker = await pickerController.create({
      cssClass: 'time-pick-picker',
      columns: [_getDColumns(_timePickList, dColIdx), _getHColumns(_timePickList?.[dColIdx]?.timeList, type === 'order' ? asapTime : productAsapTime, hColIdx)],
      buttons: (type === 'order' ? canNow : productCanNow) ? [
        {
          text: i18n.t(`newCart.timeFor_${cartMobx.info.eatType}`, { time: type === 'order' ? asapTime.timeStr : productAsapTime.timeStr }),
          role: 'cancel',
          handler: () => {
            type === 'order' ? timePickMobx.reset() : timePickMobx.resetProduct()
            setTimeout(() => {
              callback && callback()
            })
          }
        },
        {
          text: i18n.t('common.ok'),
          handler: () => {
            type === 'order' ? timePickMobx.setSelectedInfo(_selectedInfo, true) : timePickMobx.setProductSelectedInfo(_selectedInfo)
            setTimeout(() => {
              callback && callback()
            })
          }
        }
      ] : [
        {
          text: i18n.t('common.ok'),
          handler: () => {
            type === 'order' ? timePickMobx.setSelectedInfo(_selectedInfo, true) : timePickMobx.setProductSelectedInfo(_selectedInfo)
            setTimeout(() => {
              callback && callback()
            })
          }
        }
      ]
    })
    picker.addEventListener('ionPickerColChange', (ev: any) => {
      if (ev.detail.name === 'day') {
        const { options, selectedIndex } = ev?.detail
        const { timeList, dayIndex: pickDayIndex, value: pickDay } = options[selectedIndex]
        const hDom = document.querySelectorAll('ion-picker-column')[1]
        const newcol = cloneDeep(hDom.col)
        newcol.options = _getHColumns(timeList, type === 'order' ? asapTime : productAsapTime, 0)?.options
        newcol.selectedIndex = 0
        hDom.col.options.forEach(element => {
          delete element.selected
          delete element.duration
          delete element.transform
        })
        hDom.col = newcol
        picker.columns[1] = newcol
        Object.assign(_selectedInfo, {
          pickDayIndex,
          pickDay,
          pickTime: timeList[0].timeStr,
          pickTimeRange: timeList[0].pickTimeRange
        })
      } else {
        const { options, selectedIndex } = ev?.detail
        const { value: pickTime, pickTimeRange } = options[selectedIndex]
        Object.assign(_selectedInfo, {
          pickTime,
          pickTimeRange
        })
      }
    })
    picker.addEventListener('ionPickerWillPresent', (ev) => {
      const pickerWrapper = document.querySelector('ion-picker.time-pick-picker .picker-wrapper')
      const pickerToolbar = pickerWrapper.querySelector('.picker-toolbar')
      const pickerHeader = document.createElement('div')
      pickerHeader.classList.add('picker-header')
      pickerHeader.innerHTML = `<span>${i18n.t(`newCart.${cartMobx.info.eatType}time`)}</span><i class='iconfont icon-close'></i>`
      pickerHeader.querySelector('i').addEventListener('click', () => {
        picker.dismiss()
      }, true)
      pickerWrapper.insertBefore(pickerHeader, pickerToolbar)
    })
    await picker.present()
  }
}

export default TimePickController
